<template>
  <div class="data-list">
    <content-panel>
      <template v-slot:search>
        <search-box class="search-box">
          <el-form
            :inline="true"
            :model="searchForm"
            ref="searchForm"
            label-width="120px"
            size="mini"
          >
            <el-form-item label="钱包id" prop="walletId">
              <el-input
                v-model="searchForm.walletId"
                type="number"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="营销类型" prop="walletType">
              <el-select v-model="searchForm.walletType" clearable @change="onSearch">
                <el-option v-for="item in walletType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="操作类型" prop="operationType">
              <el-select v-model="searchForm.operationType" clearable @change="onSearch">
                <el-option v-for="item in operationType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="经销商" prop="cusName"> 
              <el-input
                v-model="searchForm.cusName"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="操作人/微信昵称" prop="createName">
              <el-input
                v-model="searchForm.createName"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="活动ID" prop="activityId">
              <el-input
                type="number"
                v-model="searchForm.activityId"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="钱包类型" prop="activityType">
              <el-select v-model="searchForm.activityType" clearable @change="onSearch">
                <el-option label="全部" value=""></el-option>
                <el-option label="老钱包" value="1"></el-option>
                <el-option label="新钱包" value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="操作时间" prop="updatedTime">
               <q-date-picker v-model="searchForm" ref="dateRef" />
            </el-form-item>
          </el-form>
          <template v-slot:right>
            <el-button size="small" type="primary" @click="onSearch">查询</el-button>
            <el-button size="small" @click="resetSearchForm">重置</el-button>
          </template>
        </search-box>
      </template>
      <table-panel ref="tablePanel">
        <template v-slot:header-left>
          <el-button type="primary" size="small" @click="exportData">导出</el-button>
        </template>
        <el-table
          stripe
          v-loading="loading"
          ref="tableRef"
          border
          highlight-current-row
          :data="tableData"
          :height="maxTableHeight"
        >
          <el-table-column prop="walletId" label="钱包id" align="center" width="120"></el-table-column>
          <el-table-column prop="type" label="营销类型"  align="center" width="150"></el-table-column>
          <el-table-column prop="activityId" label="活动id" align="center" width="120"></el-table-column>
          <el-table-column prop="cusName" label="经销商" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="operationType" label="操作类型" align="center" width="130"></el-table-column>
          <el-table-column prop="createdTime" label="操作时间" align="center" width="180" show-overflow-tooltip></el-table-column>
          <el-table-column prop="createName" label="操作人/微信昵称" align="center" width="200" show-overflow-tooltip></el-table-column>
          <el-table-column prop="openId" label="OpenID" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="amount" label="金额(元)" align="center" width="120"></el-table-column>
        </el-table>
        <template v-slot:footer>
          <div style="text-align: right">
            <el-pagination
              @size-change="onSizeChange"
              @current-change="onNumChange"
              :current-page="pageNum"
              :page-size="pageSize"
              :total="total"
              :page-sizes="[20, 50, 100, 200]"
              layout="total, sizes, prev, pager, next, jumper"
            >
            </el-pagination>
          </div>
        </template>
      </table-panel>
    </content-panel>
  </div>
</template>

<script>
import tableMixin from "@/utils/tableMixin";
import moment from 'moment';
export default {
  mixins: [tableMixin],
  name: "walletRecord",
  data() {
    return {
      searchForm: {
        walletId: '',
        walletType: '',
        operationType: '',
        cusName: '',
        createName: '',
        activityId: '',
        startTime: "",
        endTime: "",
        activityType: ''
      },
      walletType: [
        {value: '', label: '全部'},
        {value: 1, label: '现金红包'},
        {value: 2, label: '裂变佣金'},
        {value: 6, label: '抽奖红包'},
      ],
      operationType: [
        {value: '', label: '全部'},
        {value: 1, label: '支出'},
        {value: 2, label: '支入'},
      ],
      // 表格相关
      tableData: [],
      pageSize: 100,
      pageNum: 1,
      total: 0,
      filterParam: {},
      loading: false
    };
  },
  methods: {
    init() {
      this.onSearch();
    },
    getList() {
      this.loading = true;
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        filterData: {
          ...this.filterParam,
        },
      };
      this.$api.dataReport
        .queryRechargeList(params)
        .then(({ data: { list, total } }) => {
          this.tableData = list || [];
          this.total = total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSizeChange(pageSize) {
      this.pageSize = pageSize;
      // 切换每页条数后从第一页查询
      this.pageNum = 1;
      this.getList();
    },
    onNumChange(pageNum) {
      this.pageNum = pageNum;
      this.getList();
    },
    resetSearchForm() {
      this.$refs.searchForm.resetFields();
      this.initDate()
      this.filterParam = {};
      this.onSearch();
    },
    onSearch() {
      // 每次搜索都初始化搜索条件，重新添加合法的条件
      this.filterParam = {};
      for (const [key, val] of Object.entries(this.searchForm)) { 
        if (typeof val !== "undefined" && val !== null && val !== "") {
          this.filterParam[key] = val;
        }
      }
      this.pageNum = 1;
      this.getList();
    },
    initDate() {
      this.searchForm.startTime = ''
      this.searchForm.endTime = ''
      this.$refs.dateRef.reset()
    },
    exportData() {
      let params = {
        ...this.filterParam,
      };
      this.$api.common.doExport("queryRechargeList", params).then(() => {
        this.$message.success("导出操作成功，请前往导出记录查看详情");
      });
    }
  },
  created() {
    this.init();
  },
};
</script>
<style lang="stylus" scoped>

</style>
